import { get, del } from "@/services/axiosUitils";
import { HolidayListResponse } from "@/utils/types/Holiday/Holiday";

const base = "/tenant-core/cms-holidays/";

class HolidayService {
  getHolidays = async (
    page: number,
    pageSize: number,
    search?: string
  ): Promise<HolidayListResponse> => {
    const params: Record<string, string | number> = {
      page,
      page_size: pageSize,
    };
    const q = search?.trim();
    if (q) {
      params.search = q;
    }
    return await get<HolidayListResponse>(base, { params });
  };

  deleteHoliday = async (id: string): Promise<HolidayListResponse> => {
    return await del<HolidayListResponse>(`${base}${id}/`);
  };
}

export default new HolidayService();
